import { render } from "./GeofenceList.vue?vue&type=template&id=18189e32&scoped=true"
import script from "./GeofenceList.vue?vue&type=script&lang=js"
export * from "./GeofenceList.vue?vue&type=script&lang=js"

import "./GeofenceList.vue?vue&type=style&index=0&id=18189e32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18189e32"]])

export default __exports__